import { NavLink } from 'react-router-dom';
import css from './Sidebar.module.css';

function Sidebar() {
    const active = (isActive) => {
        return isActive ? css.active : css.link;
    };

    return (
        <div className={css.menu}>
            <NavLink to="/" className={({ isActive }) => active(isActive)}>
                <i className="fa-solid fa-gauge"></i>
                <span className={css.title}>Dashboard</span>
            </NavLink>
            <div className={css.groupHeader}>
                <span>Sales</span>
                <NavLink to="/schedule" className={({ isActive }) => active(isActive)}>
                    <i className="fa-regular fa-calendar"></i>
                    <span className={css.title}>Schedule</span>
                </NavLink>
                <NavLink to="/customer" className={({ isActive }) => active(isActive)}>
                    <i className="fa-regular fa-handshake"></i>
                    <span className={css.title}>Customers</span>
                </NavLink>
                <NavLink to="/contract" className={({ isActive }) => active(isActive)}>
                    <i className="fa-solid fa-file-contract"></i>
                    <span className={css.title}>Contracts</span>
                </NavLink>
                <NavLink to="/invoice" className={({ isActive }) => active(isActive)}>
                    <i className="fa-solid fa-coins"></i>
                    <span className={css.title}>Invoices</span>
                </NavLink>
                <NavLink to="/request" className={({ isActive }) => active(isActive)}>
                    <i className="fa-regular fa-bell"></i>
                    <span className={css.title}>Requests</span>
                </NavLink>
            </div>
            <div className={css.groupHeader}>
                <span>Training</span>
                <NavLink to="/student" className={({ isActive }) => active(isActive)}>
                    <i className="fa-solid fa-id-badge"></i>
                    <span className={css.title}>Students</span>
                </NavLink>
                <NavLink to="/course" className={({ isActive }) => active(isActive)}>
                    <i className="fa-solid fa-person-chalkboard"></i>
                    <span className={css.title}>Courses</span>
                </NavLink>
                <NavLink to="/program" className={({ isActive }) => active(isActive)}>
                    <i className="fa-regular fa-file-lines"></i>
                    <span className={css.title}>Programs</span>
                </NavLink>
                <NavLink to="/tna" className={({ isActive }) => active(isActive)}>
                    <i className="fa-solid fa-glasses"></i>
                    <span className={css.title}>TNAs</span>
                </NavLink>
                <NavLink to="/enroll" className={({ isActive }) => active(isActive)}>
                    <i className="fa-solid fa-arrows-rotate"></i>
                    <span className={css.title}>Enroll</span>
                </NavLink>
                <NavLink to="/certificate" className={({ isActive }) => active(isActive)}>
                    <i className="fa-solid fa-award"></i>
                    <span className={css.title}>Certificates</span>
                </NavLink>
            </div>
            <div className={css.groupHeader}>
                <span>Quality</span>
                <NavLink to="/staff" className={({ isActive }) => active(isActive)}>
                    <i className="fa-solid fa-signature"></i>
                    <span className={css.title}>Staff</span>
                </NavLink>
                <NavLink to="/audit" className={({ isActive }) => active(isActive)}>
                    <i className="fa-solid fa-magnifying-glass"></i>
                    <span className={css.title}>Audits</span>
                </NavLink>
                <NavLink to="/event" className={({ isActive }) => active(isActive)}>
                    <i className="fa-solid fa-triangle-exclamation"></i>
                    <span className={css.title}>Events</span>
                </NavLink>
                <NavLink to="/compliance" className={({ isActive }) => active(isActive)}>
                    <i className="fa-solid fa-section"></i>
                    <span className={css.title}>Compliance</span>
                </NavLink>
            </div>
        </div>
    );
}

export default Sidebar;
